@switch (columnName) {
  @case ('from') {
    {{ element.from | date: dateTimeFormat }}
  }
  @case ('to') {
    {{ element.to | date: dateTimeFormat }}
  }
  @case ('position') {
    {{ element.position?.name }}
  }
  @case ('nextOfKin') {
    {{ element.nextOfKin?.name }}
  }
  @case ('nextOfKinPhone') {
    {{ element.nextOfKin?.phoneNumber }}
  }
  @case ('name') {
    <div class="display-flex align-items-center">
      @if (!element.isDisabled) {
        <app-ui-navigate-to-person
          [id]="element.userId"
          type="user"
          buttonClass="m-0 small-icon"
        ></app-ui-navigate-to-person>
        {{ element.name }}
      }
      @if (element.isDisabled) {
        <div class="split-activity-cell divider-bottom"></div>
      }
    </div>
  }
  @case ('workSchedule') {
    @if (!element.hasAssignedWorkSchedules && element.hasWatchDuties) {
      <button mat-button [matTooltip]="'noWorkScheduleWarning' | translate">
        <mat-icon>warning</mat-icon>
      </button>
    }
  }
  @case ('edit') {
    @if (!element.isDisabled) {
      <app-ui-button
        class="small-icon"
        buttonType="icon-button"
        icon="edit"
        (click)="editCrewMember(element)"
        [privilege]="Privileges.TripCrewUpdate"
      ></app-ui-button>
    }
  }
  @case ('delete') {
    @if (!element.isDisabled) {
      <app-ui-button
        class="small-icon"
        buttonType="icon-button"
        icon="delete"
        [privilege]="Privileges.TripCrewDelete"
        appConfirmDialog
        [content]="content"
        confirmTitle="removeCrewMembers"
        (confirmed)="deleteCrewMember(element)"
      ></app-ui-button>
    }
    <ng-template #content>
      <p class="error">
        {{ 'tripCrewRemoveWarning' | translate }}
      </p>
    </ng-template>
  }
  @case ('availability') {
    <app-ui-pill [name]="availabilityStatus" [customLabel]="true">
      {{ availabilityLabel | uppercase }}
    </app-ui-pill>
  }
  @case ('roles') {
    @for (role of element.roles; track role) {
      <div>
        {{ role.name }}
      </div>
    }
  }
  @default {
    {{ element[columnName] }}
  }
}
